import React from "react";
import { Container, Col, Row } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";
// import "./../../Products/Faq/Faq.css";
import AskFaq from "./../../../../Images/askFaq.png";
function IpoFAQ() {
  return (
    <>
      <section className="faq-block">
        <Container>
          <Row>
            <Col md={8}>
              <h1>Frequently Asked Questions</h1>
              <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="0">
                  <Accordion.Header>Q1. What is an IPO?</Accordion.Header>
                                  <Accordion.Body className="textjustify">
                    <p>
                      IPO is a public offering in which a private company (that
                      has a handful of shareholders) is taken public by listing
                      it on the stock exchange and offering its shares to
                      investors in the primary market. A process used in IPO
                      helps inefficient price discovery of the securities. The
                      issuer provides a price band within which investors may
                      bid, and the final price is determined by the issuer only
                      after the bidding process has concluded. Prospective
                      buyers are given information about the proposed offering
                      in the form of a lengthy document known as a prospectus.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                  Q2. How can I invest in IPO through Moneysukh?
                  </Accordion.Header>
                                  <Accordion.Body className="textjustify">
                    <ul>
                      <li>Visit trade.moneysukh.com and login through your Moneysukh User ID & password. </li>  
                      <li>Navigate to the IPO area and select the IPO in which you want to invest.</li>  
                      <li>Fill in the essential information such as price, quantity, and so on.</li>  
                      <li>Complete the payment process. You've now successfully applied for the IPO.</li>  
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                  Q3. Where can I check my IPO allotment status?
                  </Accordion.Header>
                                  <Accordion.Body className="textjustify">
                    <ul>
                      <li>Visit trade.moneysukh.com and login through your Moneysukh User ID & password. </li>
                      <li>Navigate to the Portfolio section and choose Holding.</li>
                      <li>You may check your allocation status under the Holding section.</li>
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3">
                  <Accordion.Header>
                    Q4. What are the investment limits for individual investors
                    in IPOs?
                  </Accordion.Header>
                                  <Accordion.Body className="textjustify">
                    <p>
                      The Securities and Exchange Board of India has increased
                      the maximum size of bids that retail investors can make in
                      an initial public offering (IPO) using the Unified
                      Payments Interface (UPI). Sebi raised the limit from Rs 2
                      lakh to Rs 5 lakh in a circular issued.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="4">
                  <Accordion.Header>
                  Q5. Where can I look for upcoming and past IPOs?
                  </Accordion.Header>
                                  <Accordion.Body className="textjustify">
                   <ul>
                    <li>Visit trade.moneysukh.com and login through your Moneysukh User ID & password.</li>
                    <li>Navigate to the IPO section.</li>
                    <li>There, you will view all past, current, and upcoming IPOs.</li>
                   </ul>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </Col>
            <Col md={4}>
              <div className="faq-beta">
                <img className="img-fluid" src={AskFaq} alt={AskFaq} />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default IpoFAQ;
